import React from 'react';

const UsAddress = () => {
    return (
        <div className='border p-8 bg-red-300 w-full'>
            <div className='flex justify-between items-center'>
                <div>
                    <h1>Street: 13 sherryforrth dr, Maritta 30066</h1>
                    <h1>City: Maritta</h1>
                    <h1>Phone: +(404) 542 4062</h1>
                    <h1>Email: freelancerrahulroni@gmail.com</h1>
                </div>
                <div>
                    <h1 className='text-2xl'>USA OFFICE</h1>
                </div>
            </div>
        </div>
    );
};

export default UsAddress;